import { render } from "./ConfirmBackToIndexModal.vue?vue&type=template&id=2d858b24"
import script from "./ConfirmBackToIndexModal.vue?vue&type=script&lang=js"
export * from "./ConfirmBackToIndexModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__